/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Show_AgendaInputs */

const cs_calendar_show_agenda = /** @type {(inputs: Calendar_Show_AgendaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenda`)
};

const en_calendar_show_agenda = /** @type {(inputs: Calendar_Show_AgendaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenda`)
};

/**
* | output |
* | --- |
* | "Agenda" |
*
* @param {Calendar_Show_AgendaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_show_agenda = /** @type {((inputs?: Calendar_Show_AgendaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Show_AgendaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_show_agenda(inputs)
	return cs_calendar_show_agenda(inputs)
});